export type FormFieldCell = {
  id: string;
  parent: React.ReactElement | null;
  children: (React.ReactElement | null)[];
};

const FormFieldCells = ({ formFieldCells }: { formFieldCells: FormFieldCell[] }) => {
  if (!formFieldCells.length) return null;

  return (
    <>
      {formFieldCells.map((fieldCell) =>
        !fieldCell.children.length ? (
          <>{fieldCell.parent}</>
        ) : (
          <>
            <div className="flex gap-2" key={fieldCell.id}>
              <div className="flex-1">{fieldCell.parent}</div>
              {fieldCell.children.map((child, index) => (
                <div className="flex-1" key={`${fieldCell.id}-child-${index}`}>
                  {child}
                </div>
              ))}
            </div>
          </>
        )
      )}
    </>
  );
};

export default FormFieldCells;
